import React from "react"

import Button from "@knowit-alma/common/src/components/atoms/Button/Button"

import styles from "./Ticker.module.scss"

const Ticker = ({ text, link, variant }) => {
  return (
    <section
      className={`${styles.element} section-break-out section-break-out-no-margins-mobile make-full-width-on-mobile attached-to-siblings`}
    >
      <div className="container">
        <div className={styles.container}>
          {text && <p>{text}</p>}
          {link && (
            <div className={styles.link}>
              <Button
                href={link.url}
                internalLink={link.target !== "_blank"}
                linkTarget={link.target}
                variant="black"
                size="small"
              >
                {link.title}
              </Button>
            </div>
          )}
        </div>
      </div>
    </section>
  )
}
export default Ticker
